<template>
  <div class="ques-sheet" v-if="questions">
    <ul>
      <li v-for="(item, index) in questions" :key="index" class="question-list-item">
        <div class="item-title" @click="toggle(index)">
          <span class="group-fold fr"></span>
          <p class="fl">{{item.viewTypeName}}</p>
        </div>
        <ul class="item-list">
          <li v-for="(ele,idx) in item.list" :key="idx" class="list-ele" @click="toggleQues(index,idx)">{{idx + 1}}&nbsp;
            <span class="red" v-html="sign(ele)" />
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ExamQuesList',
    computed: {
      ...mapGetters([
        'questions',
        'currentQuestion'
      ])
    },
    methods: {
      //切换题目(答题卡)
      toggleQues(quesType, quesIndex) {
        this.$emit('quesFn', quesType, quesIndex, this.currentQuestion)
      },
      //答题卡标记字符
      sign(ques) {
        if(ques.isMark) {
          return '?'
        } else if(ques.isAnswer) {
          return ' '
        } else {
          return '*'
        }
      },
      //切换显隐
      toggle(index) {
        if ($('.ques-sheet').find('.question-list-item').eq(index).hasClass('active')) {
          $('.ques-sheet').find('.question-list-item').eq(index).removeClass('active')
        } else {
          $('.ques-sheet').find('.question-list-item').eq(index).addClass('active')
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
 $imgUrl: '~@/assets/images/doExam/';
 .ques-sheet{
   .active{
     .item-list{
       display: none;
     }
     .group-fold{
       background: url($imgUrl + "subShow.gif") no-repeat !important;
     }
   }
   .question-list-item{
     display: block;
     padding-bottom: 5px;
     .item-title{
       font-size: 11px;
       overflow: hidden;
       line-height: 28px;
       text-align: center;
       background: url($imgUrl + 'btn-line.gif') repeat-x;
       cursor: pointer;
       .group-fold{
         display: inline-block;
         width:35px;
         height:12px;
         cursor: pointer;
         transition: .3s all;
         background: url($imgUrl + "subHide.gif") no-repeat;
         margin:8px 10px 0 0;
       }
     }
     ul.item-list{
       li{
         display: inline-block;
         width: 30px;
         height: 30px;
         font-size: 14px;
         line-height: 28px;
         text-align: center;
         border: 1px solid #fff;
         background: #ddebf6;
         cursor: pointer;
         .red{color: #f00;}
       }
     }
   }
 }
</style>
